import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { RumListItemProps } from '../../../types';

import './RumListItem.css';

function RumListItem(props: RumListItemProps): JSX.Element {
    const { onRumSelection, rum } = props;
    
    function formattedDateTime(dateString: string): string {
        const date = new Date(Date.parse(dateString));

        let ampm = "AM";

        let hours = date.getHours();
        if(hours > 12) {
            hours = hours - 12;
            ampm = "PM";
        } else if(hours === 0) {
            hours = 12;
        } else if(hours === 12) {
            ampm = "PM";
        }

        return date.toDateString() + ", " + hours + ":" + String(date.getMinutes()).padStart(2, '0') + " " + ampm;
    }
        
    let requestColor = rum && "approver" in rum ? "lime" : rum && "requested_on" in rum ? "yellow" : "red"
    let displayString = "";

    let rumDisplayName = rum.bevager_name;
    if(rum.inventory_id !== undefined && rum.inventory_id !== null) {
        rumDisplayName += ", #" + rum.inventory_id;
    }

    if(!!rum.rejected_on) {
        let rejectionReason = "No reason given"
        if(!!rum.rejection_reason) {
            rejectionReason = rum.rejection_reason;
        }
        requestColor = "red";
        displayString = "Rejected By " + rum.approver + " Reason: " + rejectionReason;
    } else if(!!(rum as any).approved_on) {
        displayString = " Approved by " + rum.approver + ", " + formattedDateTime((rum as any).approved_on);
    } else if(!!rum.requested_on) {
        displayString = " Requested " + formattedDateTime(rum.requested_on);
        requestColor = "yellow";
    } else {
        displayString = " Not yet requested";
        requestColor = "red";
    }

    return (
        <div onClick={onRumSelection} style={{borderBottom: "1px solid white"}}>
            <Row>
                <Col className={(rum as any).is_immortal ? "immortal" : "regular-rum"}>{rumDisplayName}</Col>
            </Row>
            <Row>
                <Col>{rum.origin_country}</Col>
                <Col md="auto">${parseFloat(rum.price.toString()).toFixed(0)}</Col>
            </Row>
            <Row>
                <Col style={{color: rum.is_available ? "lime" : "red"}}>
                    {rum.is_available ? "Available" : "Not Available"}
                </Col>
            </Row>
            <Row>
                <Col style={{color: requestColor}}>
                    {displayString}
                </Col>
            </Row>
            {
                rum && "notes" in rum ? <Row><Col>{rum.notes}</Col></Row> : ""
            }
        </div>
    );
}

export { RumListItem };
